var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page legalaid"},[_c('Menus',{attrs:{"title":"退役军人法律援助绿色通道"}}),_c('div',{staticClass:"container-flex"},[_c('div',{staticClass:"apply"},[_c('Collect')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }